module.exports = __webpack_public_path__ + "icomoon.441fea52e48fd515d26c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ngx-select-dropdown/dist/assets/fonts/icomoon.svg?eh7l1v
// module id = 1485
// module chunks = 19